export default {
    attribute: {
        bgColor: '#fff',textColor: '#000',radius: 4,icon: null,fontSize:14, title:'监控视图', iconSize:90, iconBoxLeft:50
    },
}
